import {
  $setSelection,
  CLEAR_HISTORY_COMMAND,
  type LexicalEditor,
} from 'lexical';

/**
 * Loads a value set outside the editor (an undo of the enclosing editor, a
 * restore) into a Lexical editor, as a controlled field reloads.
 *
 * - The editor's own undo starts afresh: its entries hold the content as it
 *   was, and undoing one would re-apply an edit the outside undid.
 * - An editor that is not focused is left with no selection, since Lexical
 *   puts the DOM selection, and so focus, wherever its selection is.
 */
export function loadExternalValue(
  editor: LexicalEditor,
  load: () => void,
  tag: string | string[],
): void {
  editor.update(
    () => {
      load();
      const root = editor.getRootElement();
      if (!root?.contains(root.ownerDocument.activeElement))
        $setSelection(null);
    },
    {
      tag,
      onUpdate: () => editor.dispatchCommand(CLEAR_HISTORY_COMMAND, undefined),
    },
  );
}
